import { useRouteContext } from './useRouteContext';

import type { ClientRoute } from '../types';

interface UseRouteArgs {
  url: string;
}

export function useRoute<T extends ClientRoute = ClientRoute>({
  url,
}: UseRouteArgs): T {
  const routes = useRouteContext();
  const route = routes[url];

  return (route as T) ?? {};
}
